const o = window;
o.o_global ||= {}, o.o_util ||= {};
const t = o.otto ?? {};
export {
  t as o
};
/*                                             */
